// extracted by mini-css-extract-plugin
module.exports = {"root":"StepRouter_root__1YOi4","placeholder":"StepRouter_placeholder__1C9Ug","stepId":"StepRouter_stepId__2vyBw","mockButton":"StepRouter_mockButton__313DE"};